import { render, staticRenderFns } from "./miniApp.vue?vue&type=template&id=4dbf8036&scoped=true"
import script from "./miniApp.vue?vue&type=script&lang=js"
export * from "./miniApp.vue?vue&type=script&lang=js"
import style0 from "./miniApp.vue?vue&type=style&index=0&id=4dbf8036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf8036",
  null
  
)

export default component.exports